import styled from 'styled-components';

export const Container = styled.div`
  .added-itens {
    color: ${(props) => props.theme.$primary};
    background: ${(props) => props.theme.$primary_light};
    border-radius: 0.15rem;
    border: 1px solid ${(props) => props.theme.$primary_medium};
  }
  .added-itens button {
    border-width: 0 1px 0 0;
    border-color: ${(props) => props.theme.$primary_medium};
    background: ${(props) => props.theme.$primary_light};
    border-radius: 0.15rem 0 0 0.15rem;
  }
  .added-itens button:hover {
    border-color: ${(props) => props.theme.$primary_medium};
    background: ${(props) => props.theme.$primary_light};
    text-decoration: none;
    color: ${(props) => props.theme.$primary};
  }
`;
